import { ComponentPropsWithoutRef } from 'react';

import classNames from 'classnames';

import styles from './Spinner.module.css';

export type SpinnerProps = Omit<
  ComponentPropsWithoutRef<'span'>,
  'children'
> & {
  // Diameter of the spinner. Defaults to `1em` so it scales with the
  // surrounding font size (handy as a button icon).
  size?: string | number;
};

// Circular loading spinner. BUI has no spinner/progress primitive, so this is
// the shared CSS-token replacement for MUI's CircularProgress — use it as a
// button/icon-slot loading indicator or wherever a small inline spinner is
// needed. The colour follows `currentColor`.
export const Spinner = ({
  size = '1em',
  className,
  style,
  'aria-label': ariaLabel,
  ...rest
}: SpinnerProps) => (
  <span
    className={classNames(styles.root, className)}
    style={{ width: size, height: size, ...style }}
    role={ariaLabel ? 'progressbar' : undefined}
    aria-label={ariaLabel}
    aria-hidden={ariaLabel ? undefined : true}
    {...rest}
  />
);
